'use strict';

var _ = require('underscore');

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
module.exports = function applyMiddleware(middlewears) {

  middlewears = _.isArray(middlewears) ? middlewears : [middlewears];
  
  return  function curriedStore(nextCreateStore) {
    return function newCreateStore(reducer, initialState) {
      var store = nextCreateStore(reducer, initialState);
      var dispatch = store.dispatch;
      var chain = [];

      var middlwareAPI = {
        getState: store.getState,
        dispatch: function newDispatch(action) {
          return dispatch(action);
        }
      };

      chain = _.map(middlewears, function(middleware) {
        return middleware(middlwareAPI);
      });

      var composedChain = _.compose.apply(null, chain);
      dispatch = composedChain(store.dispatch);

      return _.extend({}, store, { dispatch: dispatch });
    };
  };
};
